import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import Form from "view/component/Form";
import withReference from "view/hoc/withReference";
import {
  fetchSexs,
  getDistrics,
  getReligions,
  getJobs,
  packagingRef,
  nettoRef,
  getCities,
} from "view/portal/DataProvider";
import useDataRequesting from "view/hooks/useDataRequesting";
import apiService from "apiService";
import Table from "view/component/Table";
import AddProduct from "./AddProduct";
import { toast } from "view/component/Alert";
import FormValidator from "view/component/formValidator";
import validator from "validator";


const FormPemohon = ({ type, data, setStep, idJadwal, isShow, setData }) => {
  const { results, setRequest } = useDataRequesting();
  const [dataVillages, setDataVillages] = useState([]);
  const [dataVillagesIRT, setDataVillagesIRT] = useState([]);
  const [refDis, setrefDis] = useState([]);


  const [districtValue, setDistrictValue] = useState("");
  const [citiesValue, setcitiesValue] = useState("");
  const [villageVal, setvillageVal] = useState();
  const [villageValIrt, setvillageValIrt] = useState();

  const [districtValueIrt, setDistrictValueIrt] = useState("");
  const [isFormShow, setIsFormShow] = useState(false);
  const [nik, setNIK] = useState("");
  const [histories, setHistories] = useState("");
  const [refJenisPangan, setJenisPangan] = useState([]);
  const [packaging_id, setPackagingId] = useState([]);
  const [production_scheme, setProductionSchema] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [param, setParam] = useState({
    irt_id: "",
    nik: "",
    name: "",
    last_name: "",
    address: "",
    sex: 1,
    birth_place: "",
    birth_date: "",
    village_id: "",
    job_id: "",
    religion_id: "",
    marital_status_id: "1",
    contact: "",
    irt_address: "",
    irt_name: "",
    pic_production_name: "",
    pic_nik: "",
    email: ""
  });
  const [modal, setModal] = useState(false)
  const [product, setProduct] = useState([
    {
      ref_jenis_pangan_id: '',
      trade_name: "",
      packaging_id: [],
      netto: "",
      netto_id: 1,
      composition: "",
      expired_in: 1,
      expired_unit: "hari",
      procution_scheme: "",
    },
  ]);

  useEffect(() => {
    if (results?.data) {
      let response = villagesMapping(results.data.villages);
      setDataVillages(response);
    } else {
      setDataVillages([]);
    }
  }, [results]);

  useEffect(() => {
    getJenisPangan();
  }, [refJenisPangan.length]);

  const getJenisPangan = async () => {
    const res = await apiService.get("/pirt/jenis_pangan/read");
    let dataPangan = [];
    if (res.code === 200) {
      res.data.map((d, k) => {
        dataPangan.push({ value: d.id, label: d.name });
      });
      setJenisPangan(dataPangan);
    }
  };
  const villagesMapping = (lists) =>
    lists.map((list) => ({ value: list.id, label: list.name }));

  const districtsMapping = (lists) =>
    lists.map((list) => ({ value: list.id, label: list.name }));

  const districtChangeHandle = (e, props) => {
    if (!e) {
      props.setFieldValue("village_id", "");
    }
    setDistrictValue(e);

  };

  const changeCitiestValue = (e) => {
    if (!e) {
      setDistrictValue('')
    }
    setcitiesValue(e);

  };

  useEffect(() => {
    if (districtValue !== '') {
      setRequest({
        url: `/demograph/districts/find/${districtValue?.value}`,
        method: "get",
      });
    }
  }, [districtValue])

  useEffect(() => {
    if (citiesValue !== '') {
      getDs();
    }
  }, [citiesValue])

  const getDs = async () => {
    const res = await apiService.get(`/demograph/cities/find/${citiesValue?.value}`);
    if (res) {
      setrefDis(districtsMapping(res.data.districts))
    } else {
      setrefDis([])
    }
  }

  const districtChangeHandleIRT = async (e, props) => {
    if (!e.value) {
      props.setFieldValue("irt_village_id", "");
    }
    setDistrictValueIrt(e);
    const res = await apiService.get("/demograph/districts/find/" + e.value);
    res.code === 200 ? setDataVillagesIRT(villagesMapping(res.data.villages)) : setDataVillagesIRT([])
  };

  const getDataByNik = async (nik) => {
    let result = await apiService.get("/pirt/form_irt/read/" + nik);
    if (result.code === 200) {
      setHistories(result.data);
    }
  };

  const showForm = () => {
    if (!histories.length) {
      setIsFormShow(true);
      setHistories("");
    } else {
      setIsFormShow(true);
      setHistories("");
    }
  };

  const closeForm = () => {
    setIsFormShow(false);
  };

  const postIRTTrans = async (values) => {
    let response = await apiService.post("/pirt/form_irt/create", values);
    if (response && response.code == 200) {
      setData({ formIRT: response.data });
      setStep(2);
    }
  };
  const getValue = (value) => {
    let data = [];
    if (value !== null) {
      value.map((dat, e) => {
        data.push(dat.value);
      });
      return data;
    }
  };

  const generatePackage = (value) => {
    let data = [];
    if (value !== null) {
      value.map((dat, e) => {
        data.push({ label: dat.packaging_id, value: dat.packaging_id });
      });
      return data;
    }
  };

  const generateProduct = (dat, set) => {
    let param = [];
    if (set === "new") {
      dat.map((data, index) => {
        param.push({
          ref_jenis_pangan_id: data.ref_jenis_pangan_id,
          trade_name: data.trade_name,
          packaging_id: getValue(data.packaging_id),
          netto: data.netto,
          netto_id: data.netto_id,
          composition: data.composition,
          expired_in: data.expired_in,
          expired_unit: data.expired_unit,
          procution_scheme: data.procution_scheme,
        });
      });
    } else {
      for (let index = 0; index < dat.length; index++) {
        for (let i = 0; i < dat[index].products.length; i++) {
          param.push({
            ref_jenis_pangan_id: dat[index].products[i].ref_jenis_pangan_id,
            trade_name: dat[index].products[i].trade_name,
            packaging_id: generatePackage(dat[index].products[i].packages),
            netto: dat[index].products[i].netto,
            netto_id: dat[index].products[i].netto_id,
            composition: dat[index].products[i].composition,
            expired_in: dat[index].products[i].expired_in,
            expired_unit: dat[index].products[i].expired_unit,
            procution_scheme: dat[index].products[i].procution_scheme_base64,
          })

        }

      }
    }
    return param;
  }

  const getValueId = (value) => {
    let data = [];
    if (value !== null) {
      value.map((dat, e) => {
        data.push(dat.packaging_id);
      });
      return data;
    }
  };

  const handleFileChange = async (e) => {
    e.persist();
    // console.log(e);
    if (!validate(e.target.files[0])) return "";
    // console.log(validate(e.target.files[0]));

    setIsLoading(true);
    const fileBase64 = await toBase64(e.target.files[0]);
    setProductionSchema(fileBase64);
  };
  const toBase64 = async (file) => {
    if (await file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    }
  };

  function validate(file, maxSize = 1000000, extension = "pdf,jpg,jpeg,png") {
    let thisError;
    const extensions = extension.split(",").map((validate) => validate);
    const arrFileName = file.name.split(".");
    const fileExtension = arrFileName[arrFileName.length - 1].toLowerCase();

    if (!extensions.includes(fileExtension)) {
      thisError = `extensi file harus ${extension}`;
      setError(thisError);
      return false;
    } else if (file.size > maxSize) {
      thisError = `ukuran file melebihi ${maxSize / 1024} KB`;
      setError(thisError);
      return false;
    } else {
      setError("");
      return true;
    }
  }

  useEffect(() => {
    if (type === 'penyuluhan') {
      showForm(); setParam({
        irt_id: "",
        nik: "",
        name: "",
        last_name: "",
        address: "",
        sex: 1,
        birth_place: "",
        birth_date: "",
        village_id: "",
        job_id: "",
        religion_id: "",
        marital_status_id: "1",
        contact: "",
        irt_address: "",
        irt_name: "",
        pic_production_name: "",
        pic_nik: "",
        email: ""
      }); setProduct([{
        ref_jenis_pangan_id: '',
        trade_name: "",
        packaging_id: [],
        netto: "",
        netto_id: 1,
        composition: "",
        expired_in: 1,
        expired_unit: "hari",
        procution_scheme: "",
      }])
    }
  }, [type]);

  if (!isShow) return "";
  console.log(data.refCities)
  return (
    <>
      {type !== 'penyuluhan' ?
        <Form>

          <Form.Row>
            <Form.Column lg={6} md={12}>
              <Form.TextInput
                label="NIK pendaftar"
                name="nik_pendaftar"
                placeholder="NIK Penangggung Jawab"
                value={nik}
                onChange={(e) => {
                  setNIK(e.target.value);
                }}
              />
              <div className="row col-md-12 mt--3 ml-1">
                <div className="col-md-5"></div>
                <div className="col-md-7"><h5 className="text-red">* NIK Penanggujawab yang Sudah Mempunyai Sertifikat PKP</h5></div>
              </div>
            </Form.Column>
            <Form.Column lg={2} md={12}>
              <button
                className="btn btn-primary"
                onClick={() => {
                  closeForm();
                  getDataByNik(nik);
                }}
              >
                cari
              </button>
            </Form.Column>
          </Form.Row>

          <Form.Row>
            <p>
              Belum pernah mendaftar dan sudah punya sertifikat penyuluhan ?{" "}
              <span onClick={() => {
                showForm(); setParam({
                  irt_id: "",
                  nik: "",
                  name: "",
                  last_name: "",
                  address: "",
                  sex: 1,
                  birth_place: "",
                  birth_date: "",
                  village_id: "",
                  job_id: "",
                  religion_id: "",
                  marital_status_id: "1",
                  contact: "",
                  irt_address: "",
                  irt_name: "",
                  pic_production_name: "",
                  pic_nik: "",
                  email: ""
                }); setProduct([{
                  ref_jenis_pangan_id: '',
                  trade_name: "",
                  packaging_id: [],
                  netto: "",
                  netto_id: 1,
                  composition: "",
                  expired_in: 1,
                  expired_unit: "hari",
                  procution_scheme: "",
                }])
              }} className="text-primary">
                Daftar Baru
              </span>

            </p>
            <b>
              jika belum silahkan pilih pendaftaran PKP(penyuluhan terlebih dahulu)
            </b>
          </Form.Row>

        </Form>
        : ''}

      <div>
        {histories && (
          <Table
            headers={["No", "ID Pendaftaran", "Nama IRT", ""]}
            data={histories}
            columnMapper={(data) => [
              data.id,
              data.irt_name,
              <button
                onClick={() => {
                  // postIRTTrans({
                  //   irt_id: data.id,
                  //   nik: data.user.nik,
                  //   name: data.user.name,
                  //   last_name: data.user.last_name,
                  //   sex: data.user.sex,
                  //   birth_place: data.user.birth_place,
                  //   birth_date: new Date(data.user.birth_date),
                  //   village_id: data.user.village_id,
                  //   address: data.user.address,
                  //   contact: data.user.contact,
                  //   religion_id: data.user.religion_id,
                  //   marital_status_id: data.user.marital_status_id,
                  //   job_id: data.user.job_id,
                  //   irt_name: data.irt_name,
                  //   irt_address: data.irt_address,
                  //   irt_village_id: data.irt_village_id,
                  //   pic_production_name: data.pic_production_name,
                  //   pic_nik: data.pic_nik ? data.pic_nik : "",
                  //   email: data.email ? data.email : '',
                  //   products : generateProduct(generateProduct(data.trx_jenis_pangan, "old"), "new")
                  // })
                  setParam({
                    ...param,
                    irt_id: data.id,
                    nik: data.user.nik,
                    name: data.user.name,
                    last_name: data.user.last_name,
                    sex: data.user.sex,
                    birth_place: data.user.birth_place,
                    birth_date: new Date(data.user.birth_date),
                    village_id: data.user.village_id,
                    address: data.user.address,
                    contact: data.user.contact,
                    religion_id: data.user.religion_id,
                    marital_status_id: data.user.marital_status_id,
                    job_id: data.user.job_id,
                    irt_name: data.irt_name,
                    irt_address: data.irt_address,
                    irt_village_id: data.irt_village_id,
                    pic_production_name: data.pic_production_name,
                    pic_nik: data.pic_nik ? data.pic_nik : "",
                    email: data.email ? data.email : ''
                  })
                  setProduct(generateProduct(data.trx_jenis_pangan, "old"))
                  setDistrictValue(data.user.villages.district_id)
                  showForm()
                }
                }
                className="btn btn-primary"
              >
                Daftar
              </button>,
            ]}
          />
        )}
      </div>
      <div className={isFormShow ? "" : "d-none"}>
        <Formik
          enableReinitialize
          initialValues={{
            ...param,
            // packaging_id: getValue(packaging_id),
            // procution_scheme: production_scheme,
            products: generateProduct(product, "new"),

          }}
          validate={(values, props) => {
            const errors = {};

            if (!values.nik) {
              errors.nik = 'Nik Harus diisi';
            } else if (values.nik.length != 16) {
              errors.nik = 'nik harus 16 digit';
            }
            if (!values.pic_production_name) {
              errors.pic_production_name = 'Nama Pemilik Harus diisi';
            } 
            if (!values.email) {
              errors.email = 'email tidak boleh kosong';
            } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
              errors.email = 'email harus benar';
            }

            if (!values.irt_name) {
              errors.irt_name = 'NIB tidak boleh kosong';
            } else if (!/^[0-9]*$/.test(values.irt_name)) {
              errors.irt_name = 'NIB harus ANGKA';
            }

            if (!values.village_id) {
              errors.village_id = 'desa PJ tidak boleh kosong';
            }

            if (!values.irt_village_id) {
              errors.irt_village_id = 'desa alamat IRT tidak boleh kosong';
            }

            //...

            return errors
          }
          }
          onSubmit={async (values, actions) => {
            let response = await apiService.post(
              "/pirt/form_irt/create",
              values
            );
            if (response && response.code == 200) {
              setData({ ...data, formIRT: response.data, idJadwal: null });
              if (type === 'penyuluhan') {
                setStep(2);
              } else {
                setStep(2)
              }

            } else {
              toast({ status: 'error', text: 'gagal disimpan' })
            }
          }}
        >
          {(props) => (
            < Form >
              {console.log(props)}
              <Form.Row>
                <Form.Column lg={6} md={12}>
                  <Form.TextInput
                    label="NIK"
                    name="nik"
                    onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                    value={props.values.nik}
                  />
                  {props.errors.nik && props.touched.nik ? (
                    <div style={{ color: 'red' }}>{props.errors.nik}</div>
                  ) : null}

                  <Form.TextInput
                    label="Nama Penangung jawab"
                    name="name"
                    onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                    value={props.values.name}
                  />
                  {/* <Form.TextInput
                    label="Nama Belakang"
                    name="last_name"
                    onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                    value={props.values.last_name}
                  /> */}
                  <Form.Select
                    label="Jenis Kelamin"
                    name="sex"
                    options={[
                      { value: 1, label: "Laki-Laki" },
                      { value: 2, label: "Perempuan" },
                    ]}
                    onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                    value={props.values.sex}
                  />
                  <Form.TextInput
                    label="Tempat Lahir"
                    name="birth_place"
                    onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                    value={props.values.birth_place}
                  />
                  <Form.DatePicker2
                    label="Tanggal Lahir"
                    name="birth_date"
                    onChange={(name, date) => setParam({ ...param, [name]: date })}
                    value={props.values.birth_date}
                  />
                  {/* <Form.Select
                    label="Kecamatan"
                    name="districts"
                    options={data.districts}
                    value={districtValue}
                    onChange={(e) => districtChangeHandle(e, props)}
                  /> */}
                  <Form.ReactSelect
                    label="Kabupaten"
                    name="cities"
                    options={data.refCities}
                    value={citiesValue}
                    onChange={(e) => changeCitiestValue(e)}
                  />
                  <Form.ReactSelect
                    label="Kecamatan"
                    name="districts"

                    options={refDis}
                    value={districtValue}
                    onChange={(e) => districtChangeHandle(e, props)}
                  />
                  <Form.ReactSelect
                    label="Kelurahan/Desa"
                    name="village_id"
                    options={dataVillages}
                    onChange={(e) => { setvillageVal(e); setParam({ ...param, village_id: e.value }) }}
                    value={villageVal}
                  />
                  {props.errors.village_id && props.touched.village_id ? (
                    <div style={{ color: 'red' }}>{props.errors.village_id}</div>
                  ) : null}
                  {/* <Form.Select
                    label="Kelurahan/Desa"
                    name="village_id"
                    options={dataVillages}
                    onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                    value={props.values.village_id}
                  /> */}
                  <Form.TextInput
                    label="Alamat"
                    name="address"
                    placeholder="RT / RW, desa , kecamatan, Kabupaten"
                    onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                    value={props.values.address}
                  />

                  <Form.TextInput
                    label="Nomor HP"
                    name="contact"
                    onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                    value={props.values.contact}
                  />
                  <Form.Select
                    label="Agama"
                    name="religion_id"
                    options={data.religions}
                    onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                    value={props.values.religion_id}
                  />
                  <Form.Radio
                    label="Status Perkawinan"
                    value={props.values.marital_status_id}
                    name="marital_status_id"
                    onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                    options={[
                      { value: 1, label: "Menikah" },
                      { value: 2, label: "Belum Menikah" },
                    ]}
                  />
                  <Form.Select
                    label="Pekerjaan"
                    name="job_id"
                    options={data.jobs}
                    onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                    value={props.values.job_id}
                  />
                </Form.Column>
                <Form.Column lg={6} md={12}>
                  <hr className="mt--1" />
                  {/* <Form.Select
                    label="Nama jenis pangan"
                    name="ref_jenis_pangan_id"
                    options={refJenisPangan}
                    onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                    value={props.values.ref_jenis_pangan_id}
                  />
                  <Form.TextInput
                    label="Nama dagang"
                    name="trade_name"
                    onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                    value={props.values.trade_name}
                  />
                  <Form.ReactSelect
                    label="Jenis kemasan"
                    name="packaging_id"
                    options={data.packaging}
                    onChange={(e) => {
                      setPackagingId(e);
                      console.log(props.values);
                    }}
                    value={packaging_id}
                    isMulti
                    isClearable
                  />
                  <div className="form-group row ">
                    <label
                      htmlFor="example-text-input"
                      className="col-lg-5  col-md-12 col-form-label col-form-label-sm form-control-label"
                    >
                      Berat bersih/isi bersih"
                    </label>
                    <div className="col-lg-7  col-md-12">
                      <div className="input-group input-group-sm">
                        <input
                          className="form-control form-control-sm"
                          type="number"
                          name="netto"
                          onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                          value={props.values.netto}
                          placeholder="berat dalam angka"
                        />
                        <select
                          name="netto_id"
                          placeholder="satuan"
                          className="form-control form-control-sm"
                          onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                          value={
                            props.values.netto_id ? props.values.netto_id : ""
                          }
                        >
                          <option value={""}>pilih</option>
                          {data.netto
                            ? data.netto.map((dat, key) => {
                              return (
                                <option key={key} value={dat.value}>
                                  {dat.label}
                                </option>
                              );
                            })
                            : ""}
                        </select>
                      </div>
                    </div>
                  </div>
                  <Form.TextInput
                    label="Komposisi"
                    name="composition"
                    onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                    value={props.values.composition}
                  />
                  <div className="form-group row ">
                    <label
                      htmlFor="example-text-input"
                      className="col-lg-5  col-md-12 col-form-label col-form-label-sm form-control-label"
                    >
                      Masa simpan/kadaluwarsa
                    </label>
                    <div className="col-lg-7  col-md-12">
                      <div className="input-group input-group-sm">
                        <input
                          className="form-control form-control-sm"
                          type="number"
                          name="expired_in"
                          onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                          value={props.values.expired_in}
                          placeholder="lama kadaluarsa (dalam angka)"
                        />
                        <select
                          name="expired_unit"
                          className="form-control form-control-sm"
                          onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                          value={
                            props.values.expired_unit
                              ? props.values.expired_unit
                              : ""
                          }
                        >
                          <option value="">pilih waktu</option>
                          <option value="jam">jam</option>
                          <option value="hari">hari</option>
                          <option value="bulan">bulan</option>
                          <option value="tahun">tahun</option>
                        </select>
                      </div>
                    </div>
                  </div> */}
                  <div className="row">
                    <div className="col-md-5">
                      <button className="btn btn-sm btn-primary" onClick={() => setModal(true)}>Data Produk</button>
                    </div>
                    <div className="bootstrap-tagsinput">
                      {product.map((data, key) =>
                        <span key={key} className={data.trade_name ? "tag badge badge-primary" : ''}>
                          {data.trade_name ? data.trade_name : 'klik pada tambah produk'}
                          <span data-role="remove" onClick={() => setProduct(product.filter((a, k) => k != key))} />
                        </span>
                      )}
                    </div>
                  </div>
                  <hr />
                  <Form.TextInput
                    label="NIB"
                    name="irt_name"
                    onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                    value={props.values.irt_name}
                  />
                  {props.errors.irt_name && props.touched.irt_name ? (
                    <div style={{ color: 'red' }}>{props.errors.irt_name}</div>
                  ) : null}
                  <Form.TextInput
                    label="Alamat IRT"
                    name="irt_address"
                    placeholder="RT / RW, desa , kecamatan, Kabupaten"
                    onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                    value={props.values.irt_address}
                  />
                  {/* <Form.Select
                    label="Kecamatan"
                    name="irt_districts"
                    options={data.districts}
                    value={districtValueIrt}
                    onChange={(e) => districtChangeHandleIRT(e, props)}
                  /> */}

                  <Form.ReactSelect
                    label="Kecamatan"
                    name="irt_districts"
                    options={data.districts}
                    value={districtValueIrt}
                    onChange={(e) => districtChangeHandleIRT(e, props)}
                  />
                  <Form.ReactSelect
                    label="Kelurahan/Desa"
                    name="irt_village_id"
                    options={dataVillagesIRT}
                    onChange={(e) => { setvillageValIrt(e); setParam({ ...param, irt_village_id: e.value }) }}
                    value={villageValIrt}
                  />
                  {props.errors.irt_village_id && props.touched.irt_village_id ? (
                    <div style={{ color: 'red' }}>{props.errors.irt_village_id}</div>
                  ) : null}

                  {/* <Form.Select
                    label="Kelurahan/Desa"
                    name="irt_village_id"
                    options={dataVillagesIRT}
                    onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                    value={props.values.irt_village_id}
                  /> */}
                  <Form.TextInput
                    label="Nama Pemilik"
                    name="pic_production_name"
                    onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                    value={props.values.pic_production_name}
                  />
                  {props.errors.pic_production_name && props.touched.pic_production_name ? (
                    <div style={{ color: 'red' }}>{props.errors.pic_production_name}</div>
                  ) : null}
                  <Form.TextInput
                    label="NIK Pemilik"
                    name="pic_nik"
                    onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                    value={props.values.pic_nik}
                  />
                  {/* <Form.TextInput
                    label="Skema proses produksi"
                    name="procution_scheme"
                    onChange={props.handleChange}
                    value={props.values.procution_scheme}
                  /> */}
                  {/* <Form.FileBrowser
                    label="Skema Produksi (jpg, jpeg, png)"
                    name="procution_scheme"
                    onChange={handleFileChange}
                  /> */}
                  <Form.TextInput
                    label="email"
                    name="email"
                    onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                    value={props.values.email ? props.values.email : ''}
                  />
                  {props.errors.email && props.touched.email ? (
                    <div style={{ color: 'red' }}>{props.errors.email}</div>
                  ) : null}
                </Form.Column>
              </Form.Row>
              <Form.Row>
                <Form.Column lg={12} md={12}>
                  <button
                    className="btn btn-primary float-right"
                    onClick={() => {
                      props.handleSubmit();
                    }}
                  // disabled ={param.irt_id ? true : false}
                  >
                    Simpan
                  </button>
                </Form.Column>
              </Form.Row>
            </Form>
          )}
        </Formik>
        {modal ? <AddProduct show={modal}
          onHide={() => setModal(false)} refjenispangan={refJenisPangan}
          product={product}
          setproduct={setProduct}
        />
          : ''}
      </div >
    </>
  );
};

export default withReference(
  [
    fetchSexs(),
    getDistrics(),
    getReligions(),
    getJobs(),
    nettoRef(),
    packagingRef(),
    getCities(),
  ],
  ["sexs", "districts", "religions", "jobs", "netto", "packaging", "refCities"]
)(FormPemohon);
